import { mapActions, mapGetters } from 'vuex'
import { dictionaryNames } from '@/scripts/consts'

export const createWorkDisabled = {
  data() {
    return {}
  },

  created() {
    this.getDictionaries([dictionaryNames.Period])
  },

  computed: {
    ...mapGetters('dictionaries', ['periodList']),

    isCreateWorkDisabled() {
      return this.periodList?.find(period => period.isCurrent)?.isBlocked ?? true
    }
  },

  methods: {
    ...mapActions('dictionaries', ['getDictionaries'])
  }
}
